import { combineReducers } from 'redux'
import appSettings, { AppSettingsState } from './appSettingsSlice'

export interface AppState {
	appSettings: AppSettingsState
}

const rootReducer = combineReducers({
	appSettings,
})

export default rootReducer

